// Live Now
export const Lives = [
  {
    id: 1,
    username: "Shakib All Hasan",
    profilePicture: "images/Shakib/pro.jpg",
  },
  {
    id: 2,
    username: "Momtaz Begum",
    profilePicture: "images/Momtaz-Begum-photo.jpg",
  },
  {
    id: 3,
    username: "Mizanur Rahman Azhari",
    profilePicture: "images/Profile/azhari-profile.jpg",
  },
];

// User Post
export const Users = [
  {
    id: 1,
    username: "Shakib Al Hasan",
    profilePicture: "images/Shakib/shakib-al-hasan.jpg",
    postPic: "images/Shakib/1.jpg",
    postTitel: "Coming live at 9.00 pm tonight. See you there!",
    video: "https://www.youtube.com/watch?v=LRtEJPSj2-8",
    time: "5:30 PM",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },
  {
    id: 2,
    username: "Momtaz Begum",
    profilePicture: "images/Momtaz-Begum-photo.jpg",
    postPic: "images/Momotaz.jpg",
    postTitel:
      "Folk is in my bloodstream I cry folk and do sing folk. My listeners are the backbone of my passion. Folksong is something I always admire and let me be in peace to sing along",
    time: "5:30 PM",
    video: "https://www.youtube.com/watch?v=DtZ3YJouLbk",
    date: "10th December",
    candidate: "360",
    pdate: "01/01/2022",
    LikeCount: "501",
    ShareCount: "140",
    CommentCount: "234",
  },
  {
    id: 3,
    username: "Srabanti Chatterjee ",
    profilePicture: "images/srabanti.jpg",
    postPic: "images/maxresdefault.jpg",
    postTitel:
      " One person draws a picture in one mind, and the mind paints in another .",
    time: "5:30 PM",
    video: "https://www.youtube.com/watch?v=uzvvDG-lRdA",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },

  {
    id: 4,
    username: "Shakib All Hasan",
    profilePicture: "images/Profile/Shakibpro.png",
    video: "https://www.youtube.com/watch?v=8wb3hiF20bQ",
    postPic: "images/Profile/ShakibPost.jpg",
    postTitel: "Coming live at 9.00 pm tonight. See you there!",
    time: "5:30 PM",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },

  {
    id: 5,
    username: "Srabanti Chatterjee ",
    profilePicture: "images/srabanti.jpg",
    video: "https://www.youtube.com/watch?v=k0w_Bapu8ac",
    date: "21th November",
    postPic: "images/Srabanti-Chatterjee-0loverays.jpg",
    postTitel:
      "Had a fantastic shoot for the upcoming film! Stay tuned my fans something interesting is coming up fort all of you!",
    time: "5:30 PM",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },
  {
    id: 6,
    username: "Shakib All Hasan",
    video: "https://www.youtube.com/watch?v=g-_SuiCxZsg",
    profilePicture: "images/Profile/Shakibpro.png",
    postPic: "images/Profile/ShakibPost.jpg",
    postTitel: "Coming live at 9.00 pm tonight. See you there!",
    time: "5:30 PM",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },

  {
    id: 7,
    username: "Momtaz Begum",
    video: "https://www.youtube.com/watch?v=efKZyB3B18A",
    profilePicture: "images/220px-Momtaz_Begum_(cropped).jpg",
    postPic: "images/Momotaz.jpg",
    postTitel:
      "“Folksong is something I always admire and let me be in peace to sing along",
    time: "5:30 PM",
    date: "10th December",
    candidate: "360",
    pdate: "01/01/2022",
    LikeCount: "501",
    ShareCount: "140",
    CommentCount: "234",
  },
  {
    id: 8,
    username: "Shakib Al Hasan",
    profilePicture: "images/Shakib/shakib-al-hasan.jpg",
    postPic: "images/Shakib/1.jpg",
    postTitel: "Coming live at 9.00 pm tonight. See you there!",
    time: "5:30 PM",
    date: "21th November",
    video: "https://www.youtube.com/watch?v=zm4roSWVehY&t=4s",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },
  {
    id: 9,
    username: "Momtaz Begum",
    profilePicture: "images/Momtaz-Begum-photo.jpg",
    postPic: "images/Momotaz.jpg",
    video: "https://www.youtube.com/watch?v=p537fHTnW8s",
    postTitel:
      "Folk is in my bloodstream I cry folk and do sing folk. My listeners are the backbone of my passion. Folksong is something I always admire and let me be in peace to sing along",
    time: "5:30 PM",
    date: "10th December",
    candidate: "360",
    pdate: "01/01/2022",
    LikeCount: "501",
    ShareCount: "140",
    CommentCount: "234",
  },
  {
    id: 10,
    username: "Srabanti Chatterjee ",
    profilePicture: "images/srabanti.jpg",
    video: "https://www.youtube.com/watch?v=Ss9VKQ9Qsk8",
    postPic: "images/Srabanti-Chatterjee-0loverays.jpg",
    postTitel:
      " One person draws a picture in one mind, and the mind paints in another .",
    time: "5:30 PM",
    date: "21th November",
    candidate: "360",
    pdate: "24/11/2021",
    LikeCount: "240",
    ShareCount: "100",
    CommentCount: "30",
  },
];

export const youtubeLink = [
  {
    link: "https://www.youtube.com/watch?v=LRtEJPSj2-8",
  },
  {
    link: "https://www.youtube.com/watch?v=zm4roSWVehY",
  },
  {
    link: "https://www.youtube.com/watch?v=tUNGAuPW-_o",
  },
  {
    link: "https://www.youtube.com/watch?v=8wb3hiF20bQ&t=21s",
  },
];

// Follow
export const Follow = [
  {
    id: 1,
    username: "Mizanur Rahman Azhari",
    FollowPic: "images/Profile/azhari-profile.jpg",
  },

  {
    id: 2,
    username: "Shakib All Hasan",
    FollowPic: "images/Shakib/pro.jpg",
  },
  {
    id: 3,
    username: "Momtaz Begum",
    FollowPic: "images/Momtaz-Begum-photo.jpg",
  },
  {
    id: 4,
    username: "Shakib Khan",
    FollowPic: "images/shakib_Khan.jpg",
  },
  {
    id: 5,
    username: "Mosharraf Karim",
    FollowPic: "images/MosharrafKarim.jpg",
  },
];

export const Following = [
  {
    id: 1,
    username: "James",
    FollowingPic: "images/James.jpg",
  },

  {
    id: 2,
    username: "Chanchal Chowdhury",
    FollowingPic: "images/chanchal.jpg",
  },
  {
    id: 3,
    username: "Srabanti Chatterjee",
    FollowingPic: "images/srabanti.jpg",
  },
];

export const Market = [
  {
    id: 1,
    jersey: "images/FootbalImage.jpg",
    back: "images/Souvenir/fundo-floral-preto-png-2.png",
    tile: "Bangladeshi Jersey",
    desc: "The product was designed for 2022 Bangladesh VS India series.",
    pro: "images/chanchal.jpg",
    price: "20.99",
    name: "Chanchal Chowdhury",
    type: "Owner",
  },

  {
    id: 2,
    jersey: "images/FootbalImage.jpg",
    back: "images/Souvenir/fundo-floral-preto-png-2.png",
    tile: "Bangladeshi Jersey",
    desc: "The product was designed for 2022 Bangladesh VS India series.",
    pro: "images/James.jpg",
    price: "8.99",
    name: "James",
    type: "Owner",
  },
  {
    id: 3,
    jersey: "images/FootbalImage.jpg",
    back: "images/Souvenir/fundo-floral-preto-png-2.png",
    tile: "Bangladeshi Jersey",
    desc: "The product was designed for 2022 Bangladesh VS India series.",
    pro: "images/srabanti.jpg",
    price: "11.99",
    name: "Srabanti Chatterjee",
    type: "Owner",
  },
];
